import { render, staticRenderFns } from "./couponTempletEdit.vue?vue&type=template&id=21b25700&"
import script from "./couponTempletEdit.vue?vue&type=script&lang=js&"
export * from "./couponTempletEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports